<div class="pdf-page app-aul-003-24" id="aul00324">
  <!-- <app-policy-header></app-policy-header> -->
  <p class="font-large" style="text-align: center">
    <b>SCHEDULE OF FORMS AND ENDORSEMENTS</b>
  </p>
  <p class="font-small">
    <b>
      The Forms and Endorsements applying to the Coverage Part described in the
      Common Policy Declarations and made part of the Policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>


  <p class="font-small"><b>Policyholder Notices and Declarations</b></p>

  <table
    class="font-extra-small"
    style="border: 1px solid black; border-collapse: collapse"
  >
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 000/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          AUL Commercial Lines Policy Jacket
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 013/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          AUL Amendatory Endorsement {{ formattedState }}
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 001/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          Common Policy Declarations
        </td>
      </tr>

      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 002/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          Supplemental Declarations
        </td>
      </tr>

      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 003/24</td>
        <td style="border: 1px solid black; padding: 3px;">Policy Schedule</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">ILP 001 01 04</td>
        <td style="border: 1px solid black; padding: 3px;">
          US Treasury Department's Office of Foreign Assets Control (OFAC)
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 008/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          Claims Reporting Information
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 009/24</td>
        <td style="border: 1px solid black; padding: 3px;">Complaints Notice</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">PRIV-0100 6/22</td>
        <td style="border: 1px solid black; padding: 3px;">Privacy Policy</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 006/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          Policyholder Disclosure Notice of Terrorism Insurance Coverage
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 010/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          Fraud Notice Multi-state
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 3px;">AUL 011/24</td>
        <td style="border: 1px solid black; padding: 3px;">
          AUL Inspection Notice
        </td>
      </tr>
    </tbody>
  </table>

  

  <p class="font-small"><b>Coverage Forms and Endorsements</b></p>

  <table class="font-extra-small" style="width: 100%">
    <tbody>
      <tr>
        <td style="vertical-align: top;">
          <table style="border: 1px solid black; border-collapse: collapse">
            <tbody>
              @if (documentFlags?.isNonCondo) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 00 10 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Buildings and Commercial Property Coverage Form
                </td>
              </tr>
            }
            @if (documentFlags?.isCondo) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 00 17 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Condominium Association Coverage Form
                </td>
              </tr>
            }
            @if (documentFlags?.isBusinessIncomeLimit) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 00 30 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Business Income (And Extra Expense) Coverage Form
                </td>
              </tr>
            }
            @if (documentFlags?.isSpecialForm) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 10 30 09 17
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Cause of Loss - Special Form
                </td>
              </tr>
            }
            @if (documentFlags?.isBasicForm) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 10 10 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Cause of Loss - Basic Form
                </td>
              </tr>
            }
            @if (documentFlags?.isEqbdSelected) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 040_26
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Equipment Breakdown Notice
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP EB_2025
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Equipment Breakdown Enhacement Endorsement
                </td>
              </tr>
            }
           
            @if (documentFlags?.isSilverEnhancement) {

              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 020/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Property Enhancement Endorsement – Silver
                </td>
              </tr>
            }
              @if (documentFlags?.isGoldEnhancement) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 021/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Property Enhancement Endorsement – Gold
                </td>
              </tr>
            }
              @if (documentFlags?.isCondoWithCertainStates) {
                <tr>
                  <td style="border: 1px solid black; padding: 3px;">
                    AUL 038/24
                  </td>
                  <td style="border: 1px solid black; padding: 3px;">
                    Condominium Coverage Extension
                  </td>
                </tr>
              }
              @if (documentFlags?.ordinanceOrLawIncluded) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 015/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Ordinance or Law
                </td>
              </tr>
            }
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  IL 00 17 11 98
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Common Policy Conditions
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 00 90 07 88
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Commercial Property Conditions
                </td>
              </tr>
              @if (documentFlags?.isLossPayee) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 12 18 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Loss payable Provisions and Loss Appraisal
                </td>
              </tr>
            }
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 014/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Minimum Earned Premium Endorsement
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 02 99 06 07
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Cancellation Changes
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 018/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Roof Valuation
                </td>
              </tr>
              @if (documentFlags?.isWindStorm) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 03 21 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Windstorm and Hail Percentage Deductible
                </td>
              </tr>
            }
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 030/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Protective Safeguards
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 031/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Burglary Protective Safeguards
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 039/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Heat Maintenance Protective Safeguards
                </td>
              </tr>
             
              @if (documentFlags?.hasTRIAReject) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 006B/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Certified Acts of Terrorism - Not Purchased Clause
                </td>
              </tr>
            }
            @if (documentFlags?.hasTRIAAccept) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 006A/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Certified Acts of Terrorism - New & Renewal Business
                  Endorsement
                </td>
              </tr>
            }
           
            </tbody>
          </table>
        </td>
        <td  style="vertical-align: top;">
          <table
            style="
              border: 1px solid black;
              border-collapse: collapse;
              margin-left: 15px;
            "
          >
            <tbody>
              @if (documentFlags?.isWindExcluded) {
                <tr>
                  <td style="border: 1px solid black; padding: 3px;">
                    CP 10 54 06 07
                  </td>
                  <td style="border: 1px solid black; padding: 3px;">
                    Windstorm or Hail Exclusion
                  </td>
                </tr>
              }
              @if (documentFlags?.isTheftExcluded) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 10 33 10 12
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Theft Exclusion
                </td>
              </tr>
              }
            @if (documentFlags?.isWaterDamageExcluded) {
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 034/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Water Damage Exclusion
                </td>
              </tr>
            }
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 019/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Cosmetic Damage to Roof Surface and Covering Exclusion
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 01 40 07 06
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Exclusion of Loss due to Virus or Bacteria
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  CP 10 75 12 20
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Cyber Incident Exclusion
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  IL 09 35 07 02
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Exclusion of Certain Computer-Related Losses
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 022/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Virtual Currency Property Not Covered
                </td>
              </tr>           
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 029/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Prior Loss Exclusion
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 016/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  War and Terrorism Exclusion
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 032/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Biological or Chemical Materials Exclusion
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 027/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Asbestos Endorsement
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 026/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Radioactive Contamination
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 024/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Seepage and Pollution
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 025/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Land Water and Air
                </td>
              </tr>              
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 035/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Solar Panel systems
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid black; padding: 3px;">
                  AUL 037/24
                </td>
                <td style="border: 1px solid black; padding: 3px;">
                  Microorganism Exclusion (Absolute)
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- <table class="w-50 font-extra-small">
    <tbody>
      <tr>
        <td>CP 00 10 10 12</td>
        <td>Buildings and Commercial Property Coverage Form</td>
      </tr>
      <tr>
        <td>CP 00 30 10 12</td>
        <td>Business Income (And Extra Expense) Coverage Form</td>
      </tr>
      <tr>
        <td>CP 10 30 09 17</td>
        <td>Cause of Loss - Special Form</td>
      </tr>
      <tr>
        <td>AUL 020/24</td>
        <td>Property Enhancement GOLD</td>
      </tr>
      <tr>
        <td>AUL 015/24</td>
        <td>Ordinance or Law</td>
      </tr>
      <tr>
        <td>IL 00 17 11 98</td>
        <td>Common Policy Conditions</td>
      </tr>
      <tr>
        <td>CP 00 90 07 88</td>
        <td>Commercial Property Conditions</td>
      </tr>
      <tr>
        <td>CP 12 18 10 12</td>
        <td>Loss payable Provisions and Loss Appraisal</td>
      </tr>
      <tr>
        <td>AUL 014/24</td>
        <td>Minimum Earned Premium Endorsement</td>
      </tr>
      <tr>
        <td>CP 02 99 06 07</td>
        <td>Cancellation Changes</td>
      </tr>
      <tr>
        <td>AUL 018/24</td>
        <td>Roof Valuation</td>
      </tr>
      <tr>
        <td>AUL 030/24</td>
        <td>Protective Safeguards</td>
      </tr>
      <tr>
        <td>AUL 031/24</td>
        <td>Burglary Protective Safeguards</td>
      </tr>
      <tr>
        <td>AUL 006B/24</td>
        <td>Certified Acts of Terrorism - Not Purchased Clause</td>
      </tr>
      <tr>
        <td>CP 10 54 06 07</td>
        <td>Windstorm or Hail Exclusion</td>
      </tr>
      <tr>
        <td>CP 10 33 06 1995</td>
        <td>Theft Exclusion</td>
      </tr>
    </tbody>
  </table>

  <table class="w-50 font-extra-small">
    <tbody>
      <tr>
        <td>AUL 034/24</td>
        <td>Water Damage Exclusion</td>
      </tr>
      <tr>
        <td>AUL 019/24</td>
        <td>Cosmetic Damage to Roof Surface and Covering Exclusion</td>
      </tr>
      <tr>
        <td>CP 01 40 07 06</td>
        <td>Virus or Bacteria Exclusion</td>
      </tr>
      <tr>
        <td>CP 10 75 12 20</td>
        <td>Cyber Incident Exclusion</td>
      </tr>
      <tr>
        <td>IP 09 35 07 02</td>
        <td>Certain Computer Related Losses</td>
      </tr>
      <tr>
        <td>AUL 016/24</td>
        <td>War and Terrorism Exclusion</td>
      </tr>
      <tr>
        <td>AUL 022/24</td>
        <td>Virtual Currency Exclusion</td>
      </tr>
      <tr>
        <td>AUL 023/24</td>
        <td>Wiring Exclusion</td>
      </tr>
      <tr>
        <td>AUL 024/24</td>
        <td>Seepage and Pollution</td>
      </tr>
      <tr>
        <td>AUL 025/24</td>
        <td>Land Water and Air</td>
      </tr>
      <tr>
        <td>AUL 026/24</td>
        <td>Radioactive Contamination</td>
      </tr>
      <tr>
        <td>AUL 027/24</td>
        <td>Asbestos Endorsement</td>
      </tr>
      <tr>
        <td>AUL 028/24</td>
        <td>Sick Building Condition(s) Exclusion</td>
      </tr>
      <tr>
        <td>AUL 029/24</td>
        <td>Prior Loss Exclusion</td>
      </tr>
      <tr>
        <td>AUL 032/24</td>
        <td>Biological or Chemical Materials Exclusion</td>
      </tr>
      <tr>
        <td>AUL 033/24</td>
        <td>Electronic Bikes and Scooters Exclusion</td>
      </tr>
    </tbody>
  </table> -->
</div>
